<template>
  <div class="systemManage-create create-image">
    <el-dialog
      v-model="dialogVisible"
      :title="
        formData.materialId
          ? $t('images.Image Details')
          : $t('images.Create Image')
      "
      :before-close="handleClose"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <div class="form-box">
        <el-form
          label-width="110px"
          style="width: 100%"
          :model="formData"
          ref="form"
          :rules="rules"
          size="small"
        >
          <el-form-item
            v-if="editData.materialId"
            :label="$t('lcd.material.Material Name')"
            prop="materialName"
          >
            <el-input
              v-model="formData.materialName"
              placeholder=""
              clearable
              maxlength="30"
              style="width: 360px"
            />
          </el-form-item>
          <el-form-item :label="$t('images.Groups')" prop="groupId">
            <el-select
              v-model="formData.groupId"
              :placeholder="$t('lcd.NewAdd.Please select material group')"
              size="small"
              style="width: 360px"
            >
              <el-option
                v-for="item in groupList"
                :key="item.codeValue"
                :label="item.codeName"
                :value="item.codeValue"
              >
                <div class="d-flex justify-content-between select-group">
                  <div>{{ item.codeName }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('itemsScenarios.ViewDialog.VisibleRange')"
            prop="openType"
            required
            v-if="
              userData.userRoleId != 1 &&
              userData.userRoleId != 2 &&
              userData.userRoleId != 3
            "
          >
            <el-radio-group v-model="formData.openType">
              <!-- 0  1 2 3 4  -->
              <!-- 超级管理员默认为3 -->
              <el-radio v-if="userData.userRoleId == 1" :label="3">{{
                $t("lcd.material.All")
              }}</el-radio>
              <!-- 运维和经销商用户上传素材默认为4 -->
              <el-radio
                v-if="userData.userRoleId == 2 || userData.userRoleId == 3"
                :label="4"
                >{{ $t("lcd.material.All") }}</el-radio
              >
              <el-radio :label="1">{{ $t("lcd.material.AllStore") }}</el-radio>
              <el-radio :label="0">{{ $t("lcd.material.ThisStore") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="formData.materialId === ''">
            <el-form-item :label="$t('images.Images')" prop="imageUrl">
              <el-upload
                class="upload-demo"
                drag
                :file-list="fileList"
                :on-change="handleChange"
                :on-remove="removeImg"
                :http-request="uploadImage"
                :before-upload="beforeUpload"
                action="#"
                multiple
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">
                  {{ $t("images.Drop file here or") }}
                  <em>{{ $t("images.click to upload") }}</em>
                  <div style="font-size: 12px; color: #ccc">
                    {{ $t("lcd.material.imgMaxUploadSize") }}{{uploadImageSizeDesc}};
                    {{ $t("lcd.material.videoMaxUploadSize") }}{{uploadVideoSizeDesc}}
                  </div>
                </div>
                <!-- <template #tip>
                  <div class="el-upload__tip">
                    jpg/png files with a size less than 3M
                  </div>
                </template> -->
                <template #file>
                  <div></div>
                  <!-- <div style="max-height:300px">
                    <el-scrollbar style="height:100%">
                      <div class="file-list d-flex">
                        <div style="flex:1">
                          <i class="el-icon-picture"></i>
                          <span style="margin-left:4px">{{scop.file.name}}</span>
                        </div>
                        <div class="delete" @click="removeImg(scop.file,scop)"><i class="el-icon-delete"></i></div>
                      </div>
                    </el-scrollbar>
                  </div> -->
                </template>
              </el-upload>
              <div class="form-img-upload">
                <el-scrollbar style="height: 100%">
                  <div
                    class="file-list"
                    v-for="(item, index) in fileList"
                    :key="item.url"
                  >
                    <div style="flex: 1">
                      <i class="el-icon-picture"></i>
                      <span style="margin-left: 4px">{{ item.name }}</span>
                    </div>
                    <div class="delete" @click="removeImg(index)">
                      <i class="el-icon-delete"></i>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item :label="$t('images.Image')" prop="imageUrl">
              <el-image :src="formData.originalUrl"></el-image>
            </el-form-item>
          </template>

          <!-- 保存按钮 -->
          <div class="form-btn-section">
            <el-button color="#28C76F" size="small" @click="handleClose">
              {{ $t("button.Cancel") }}</el-button
            >
            <el-button
              color="#28C76F"
              size="small"
              type="success"
              @click="onSubmit"
              >{{ $t("button.Save") }}</el-button
            >
          </div>
        </el-form>
        <!-- <video ref="videoElement" style="display: none"></video> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { uploadImage, batchCreateImages, updateImage } from "@/libs/api/lcd";
import { getSystemConfig } from "@/libs/api/system-parameters";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口

import imagesStore from "./store/index";

let loading;

export default {
  name: "createCustomer",
  components: {},
  props: {
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      imagesStore,
      userData: JSON.parse(localStorage.getItem("userData")),
      dialogVisible: false,
      editGroupData: {}, //编辑的分组数据
      deleteData: {},
      groupList: [],
      uploadImg: {}, //
      uploadImgsArr: [],
      fileList: [],
      initFormData: {
        materialId: "",
        materialName: "",
        groupId: "", // 素材分组
        imageUrl: "", //
        openType: 0, // 可见范围
      },
      formData: {
        materialId: "",
        groupId: "", // 素材分组
        imageUrl: "", //
        openType: 0, // 可见范围
      },
      rules: {
        groupId: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "change",
          },
        ],
        imageUrl: [
          {
            required: true,
            message: this.$t("formValidate.required fields"),
            trigger: "blur",
          },
        ],
      },
      checkVideoFormat: false,
      uploadVideoSize: 10485760,
      uploadImageSize: 10485760,
      uploadImageSizeDesc: '10M',
      uploadVideoSizeDesc: '10M',
    };
  },
  created() {},
  mounted() {
    this.getImageGroup();
    if (this.userData.userRoleId == 1) {
      this.initFormData.openType = 3;
      this.formData.openType = 3;
    }
    if (this.userData.userRoleId == 2 || this.userData.userRoleId == 3) {
      this.initFormData.openType = 4;
      this.formData.openType = 4;
    }
    this.getSystemConfigInfo();
  },
  watch: {
    editData: function (val) {
      console.log("--watch--editData", val);
      if (val && val.materialId) {
        let data = {
          ...val,
          groupId: val.groupId.toString(),
        };
        this.formData = data;
      } else {
        let obj = { ...this.initFormData };
        this.formData = obj;
        this.uploadImgsArr = [];
      }
    },
  },
  methods: {
    // 打开弹窗
    open() {
      this.dialogVisible = true;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.$refs.form.resetFields();
    },
    // 获取图片分组选项
    getImageGroup() {
      console.log(123);
      const params = {
        cateId: 40,
      };
      getCodeList(params).then((res) => {
        if (res.data.code == 1) {
          this.groupList = res.data.data;
        }
      });
    },
    getSystemConfigInfo() {
      getSystemConfig().then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.uploadImageSize = res.data.data.uploadImageSize ? res.data.data.uploadImageSize : 10485760;
          this.uploadVideoSize = res.data.data.uploadVideoSize ? res.data.data.uploadVideoSize : 10485760;
          this.uploadImageSizeDesc = res.data.data.uploadImageSizeDesc ? res.data.data.uploadImageSizeDesc : '10M';
          this.uploadVideoSizeDesc = res.data.data.uploadVideoSizeDesc ? res.data.data.uploadVideoSizeDesc : '10M';
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // beforeUpload 上传之前先验证上传图片/视频的格式和大小
    beforeUpload(file) {
      console.log("beforeUpload----file", file);
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isMP4 = file.type === "video/mp4";
      const isLtIM = file.size < this.uploadImageSize;
      const isLtMM = file.size < this.uploadVideoSize;
      const isImg = isJPG || isJPEG || isPNG
      if (!isLtIM && isImg) {
        this.$message.error(this.$t("lcd.material.MaterialSizeLimit"));
        return false;
      }
      if (!isLtMM && isMP4) {
        this.$message.error(this.$t("lcd.material.MaterialSizeLimit"));
        return false;
      }
    },
    // 上传图片
    async uploadImage(options) {
      loading = this.$loading({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log("uploadImage----options", options);
      // let userData = JSON.parse(localStorage.getItem('userData'))
      const params = new FormData();
      // console.log(options.file.type.slice(0,5))
      if (this.formData.groupId == "") {
        this.$message.error(this.$t('lcd.NewAdd.Please select material group'));
        loading.close();
        return;
      }
      params.append("groupId", this.formData.groupId);
      const materialType = options.file.type.slice(0, 5);

      params.append("fileType", materialType == "image" ? 0 : 1);
      // fd.append('storeId', '1');
      params.append("file", options.file);
      let { uploadImgsArr, fileList } = this;
      try {
        let { data } = await uploadImage(params);
        console.log("获取图片数据", data);
        if (data.state) {
          let uploadImg = data.data;
          uploadImgsArr.push({
            originalUrl: uploadImg.filePath, //	uploadImg.filePath
            size: uploadImg.fileSize, //
            materialName: uploadImg.fileName, //
            format: uploadImg.fileSuffix, // 图片后缀
            name: uploadImg.fileName,
            decodedUrl: uploadImg.decodedUrl ? uploadImg.decodedUrl : "", // 兼容视频
            duration: uploadImg.duration ? uploadImg.duration : "",
            pixels: uploadImg.pixels,
          });
          fileList.push({
            name: uploadImg.fileName,
            url: uploadImg.fileUrl + uploadImg.filePath,
          });
          let formData = {
            ...this.formData,
            imageUrl: uploadImg.filePath, //	uploadImg.filePath
          };
          // console.log('formData',formData);
          this.uploadImg = uploadImg;
          this.formData = formData;
          this.uploadImgsArr = uploadImgsArr;
          this.fileList = fileList;
          loading.close();
        } else {
          loading.close();
          this.$message.error(data.message);
          // alert(data.message)
        }
      } catch (err) {
        const { message } = err;
        loading.close();
        this.$message.error(message);
      }
    },
    handleChange(uploadFile, uploadFiles) {
      console.log(
        "handleChange----uploadFile, uploadFiles",
        uploadFile,
        uploadFiles
      );
    },
    // 删除图片
    removeImg(index) {
      let { uploadImgsArr, fileList, formData } = this;
      uploadImgsArr.splice(index, 1);
      fileList.splice(index, 1);
      if (uploadImgsArr.length === 0) {
        formData.imageUrl = "";
        this.formData = formData;
      }
      console.log("removeImg----uploadFile, uploadFiles", index);
    },
    // 表单提交
    onSubmit() {
      loading = this.$loading({
        text: "loading...",
        lock: true,
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("表单校验通过");
          this.createImage();
        } else {
          loading.close();
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 请求--- 创建素材/更新素材
    async createImage() {
      console.log(this.uploadImgsArr);
      const isAllImage = this.uploadImgsArr.every(
        (item) =>
          item.format == "png" || item.format == "jpg" || item.format == "jpeg"
      );
      const isAllVideo = this.uploadImgsArr.every(
        (item) => item.format == "mp4"
      );
      let materialType;
      if (isAllImage) {
        materialType = "0";
      }
      if (isAllVideo) {
        materialType = "1";
      }
      if (!isAllImage && !isAllVideo) {
        this.$message.error("批量上传仅支持全视频或者全图片");
        loading.close();
        return;
      }
      const merchantId = localStorage.getItem("merchantId");
      let { groupId, materialId, openType } = this.formData;
      // let userData = this.userData
      let params = {
        isEffect: 0,
        groupId,
        materialType,
        merchantId,
        openType, //是否开放(0:所属门店可见/私有1:所属商户可见 2系统级)
        images: this.uploadImgsArr,
      };
      let res = null;
      try {
        if (materialId) {
          params.materialId = materialId;
          res = await updateImage(params);
        } else {
          params.images = this.uploadImgsArr;
          params.storeId = localStorage.getItem("storeId");
          res = await batchCreateImages(params);
        }
        let response = res.data;
        if (response.state) {
          let message = this.$t("commonMessage.CreateSucess");
          this.$message({
            message: message,
            type: "success",
          });
          this.fileList = [];
          this.uploadImgsArr = [];
          this.dialogVisible = false;
          this.$emit("getData");
          loading.close();
        } else {
          loading.close();
          this.$message.error(response.message);
        }
      } catch (error) {
        loading.close();
        this.$message.error(error.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.systemManage-create.create-image {
  .form-box {
    width: 500px;
  }
  .file-list {
    display: flex;
  }
  .form-btn-section {
    margin-top: 0px;
  }
  .el-select,
  .el-input--small {
    width: 82%;
    margin-right: 10px;
  }
  ::v-deep .el-tag {
    margin-bottom: 10px;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    padding-right: 30px;
    // word-wrap: break-word;
    // word-break: break-all;
    .el-icon-close {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.select-group {
  .table-icon {
    padding: 6px;
    cursor: pointer;
    font-size: 18px;
    color: #000;
  }
}
</style>